import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointDocumentVerificationCompleteData,
  type EnrollmentJointDocumentVerificationCompleteSubmitOutput,
} from '../../../../models'

export const getEnrollmentJointDocumentVerificationCompleteDataMock: EnrollmentJointDocumentVerificationCompleteData = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/document-verification-complete',
    progress: 85,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
  },
}

export const submitEnrollmentJointDocumentVerificationCompleteDataMock: EnrollmentJointDocumentVerificationCompleteSubmitOutput =
  {
    isError: false,
    errors: [],
    activePerson: {
      path: '/enrollment/joint/funding',
    },
  }

export const mockGetEnrollmentJointDocumentVerificationCompleteData = graphql.mutation(
  'getEnrollmentJointDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({
      data: { submitJointEnrollment: getEnrollmentJointDocumentVerificationCompleteDataMock },
    })
  },
)

export const mockSubmitEnrollmentJointDocumentVerificationCompleteData = graphql.mutation(
  'submitEnrollmentJointDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({
      data: { submitJointEnrollment: submitEnrollmentJointDocumentVerificationCompleteDataMock },
    })
  },
)

export const mockEnrollmentJointDocumentVerificationComplete = [
  mockGetEnrollmentJointDocumentVerificationCompleteData,
  mockSubmitEnrollmentJointDocumentVerificationCompleteData,
]
